import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
var SelectHardwareForm = observer(function (props) {
    var isWholesalerCode = function (wholesalerCode) {
        return props.config.wholesaleCustomerCode === wholesalerCode;
    };
    var appStore = props.appStore, hardwareStore = props.hardwareStore, checkAddressStore = props.checkAddressStore, values = props.values;
    var _a = props.planStore.planDetails.formValues, contractCode = _a.contractCode, includeVoipBundle = _a.includeVoipBundle;
    React.useEffect(function () {
        if (isWholesalerCode('EA')) {
            props.saleStore.setPromo(null);
        }
    }, []);
    React.useEffect(function () {
        props.summaryStore.getSummary(props.summaryStore.contractCode, props.values.hardwareCode, props.checkAddressStore.nbnLocId, isWholesalerCode('BDF')
            ? props.summaryStore.contractCode
            : props.summaryStore.voipCode, null);
    }, [props.values]);
    return (React.createElement(Form, null,
        React.createElement("div", { className: "select-hardware" },
            hardwareStore
                .eligibleModems(contractCode, includeVoipBundle)
                .map(function (hardware) { return (React.createElement("label", { htmlFor: hardware.code.toString(), className: "checkbox", key: hardware.code },
                React.createElement(Field, { type: "radio", name: "hardwareCode", id: hardware.code, key: hardware.code, value: hardware.code, checked: values.hardwareCode === hardware.code, onClick: function () {
                        return hardwareStore.setDetailsFromForm({
                            hardwareCode: hardware.code,
                        });
                    } }),
                React.createElement("small", { className: "label" },
                    hardware.name,
                    ' ',
                    React.createElement("span", { className: "price" },
                        "$",
                        (hardware.currentPricing['sellInc'] / 100).toFixed(2)),
                    React.createElement("small", { className: "view-details" },
                        React.createElement("a", { href: hardware.detailUrl, target: "_blank" }, "View details"))),
                React.createElement("p", { className: "voip-description" }, hardware.description))); }),
            React.createElement("label", { htmlFor: "hardwareCode", className: "checkbox" },
                React.createElement(Field, { type: "radio", name: "hardwareCode", id: "hardwareCode", value: "", checked: values.hardwareCode === '', onClick: function () {
                        return hardwareStore.setDetailsFromForm({
                            hardwareCode: '',
                        });
                    } }),
                isWholesalerCode('BDF') ? (React.createElement("small", { className: "label" }, "I already have a VoIP Hardware")) : (React.createElement("small", { className: "label" },
                    "I already have a",
                    ' ',
                    checkAddressStore.providerCode === 'Uniti' ? 'Fibre' : 'nbn™',
                    ' ',
                    "compatible modem")),
                React.createElement("p", { className: "voip-description" },
                    "Please refer to your modem manufacturer and ensure your modem is compatible with the",
                    ' ',
                    checkAddressStore.providerCode === 'Uniti' ? 'fibre' : 'nbn™',
                    ' ',
                    "technology available at your premises")),
            React.createElement("div", { className: "ml-5 mt-2" },
                React.createElement("div", { className: "alert alert-info", role: "alert" },
                    React.createElement("p", null, "When switching providers, you may also be required to update your connection settings when switching from another provider."),
                    React.createElement("p", null,
                        "If you switch from another provider and using a BYO modem, we may be limited in performing our standard testing to check if your",
                        ' ',
                        React.createElement("strong", null, checkAddressStore.providerCode === 'Uniti' ? 'fibre' : 'nbn™'),
                        ' ',
                        "service is working properly.",
                        ' '))),
            React.createElement("section", { className: "footer-buttons" },
                React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: appStore.previousStep }, "Back"),
                React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next")))));
});
export var SelectHardware = inject('appStore', 'hardwareStore', 'planStore', 'summaryStore', 'checkAddressStore', 'saleStore', 'config')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.hardwareStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var hardwareStore = _a.hardwareStore;
        return hardwareStore.hardwareDetails.formValues
            ? hardwareStore.hardwareDetails.formValues
            : hardwareStore.hardwareDetails.formInitialValues;
    },
})(SelectHardwareForm));
//# sourceMappingURL=SelectHardware.js.map